import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import Styles from './styles';
function Option(props) {
    const { option, onClicked } = props;
    const { Text, Icon } = option;
    return (_jsxs(Styles.Element, { onClick: () => onClicked(option), children: [_jsx(Styles.Icon, { children: _jsx("use", { xlinkHref: Icon ? `#icon--${Icon}` : '#icon--ski' }) }), _jsx(Styles.Title, { children: Text }), _jsx(Styles.Chevron, { children: _jsx("use", { xlinkHref: "#icon--chevron-new" }) })] }));
}
export default Option;
